package com.damda.design_system.ui.views.foods

import androidx.compose.runtime.Composable
import com.damda.design_system.ui.views.compose_migrations.layouts.JSSpacer
import com.damda.design_system.ui.views.compose_migrations.texts.StyledText
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun FoodDetailTitle(title: String, subtitle: String) {
    Div {
        StyledText(
            title,
            24.px,
            color = rgb(70, 71, 75),
            fontWeight = "bold"
        )
        JSSpacer(height = 2.px)
        StyledText(
            subtitle,
            16.px,
            color = rgb(199, 197, 197)
        )
    }
}

@Composable
fun FoodDetailDescription(detail: String, ingredients: List<String>) {
    Div {
        P(
            attrs = {
                style {
                    fontSize(18.px)
                    fontWeight("bold")
                    color(Color("#46474B"))
                }
            }
        ) {
            Text("Detail & Ingredient")
        }
        JSSpacer(4.px)
        val lines = detail.split("\n")
        lines.forEachIndexed { index, line ->
            P(
                attrs = {
                    style {
                        fontSize(16.px)
                        lineHeight("22px")
                        color(Color("#B0B0B0"))
                    }
                }
            ) {
                Text(line)
            }
        }

        JSSpacer(24.px)
        Div {
            ingredients.forEach { ingredient ->
                P(
                    attrs = {
                        style {
                            fontSize(16.px)
                            color(Color("#B0B0B0"))
                        }
                    }
                ) {
                    Text("• $ingredient")
                }
                JSSpacer(2.px)
            }
        }
    }
}